export default __webpack_public_path__ + "static/hero-sustainabilitynews-e902e3c841036a2c7a82becc91728695.jpg";